module.exports = __webpack_public_path__ + "static/img/6-1.aeacd05.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/毕业照/6-1.jpg
// module id = WC/n
// module chunks = 0